export interface RegisterApiOptions {
  name: string;
  agent: RegisterAgent;
  info: RegisterInfo;
  termsOfUse?: boolean;
  shard: string;
}

export interface RegisterAgent {
  name: string;
  email: string;
  phone: string;
  password: string;
  confirm_password?: string;
}

export interface RegisterInfo {
  industry: string;
  num_employees: string;
  job_title: string;
  referrer: string;
  tags?: string[];
}

export interface RegisterStatus {
  registered: boolean;
  errorText: string;
}

export enum CountryCode {
  restOfWorld = 'rest_of_world',
  EU = 'eu',
  US = 'us_canada'
}

